module.exports = __webpack_public_path__ + "img/686B73_2A2B2D_D5D9DD_B0B3BC-256px.937402ea.png";